import { useNavigate } from "react-router-dom";
import { ExpenseApprovalPoliciesPage as ExpenseApprovalPoliciesPageView } from "@/components/ExpenseApprovalPoliciesPage";

export function ExpenseApprovalPoliciesPage() {
  const navigate = useNavigate();
  return (
    <ExpenseApprovalPoliciesPageView
      onOpenDocument={(documentId) => navigate(`/expenses/approval-policies/documents/${documentId}`)}
      onMerchantClick={(merchantId) => navigate(`/expenses/merchants/${merchantId}`)}
    />
  );
}
